import heart from 'app/images/heart.png';

const contact = {
  intro: {
    headline: 'Contact Us',
    copy:
      '<p><strong>We’d love to hear from you!</strong> Did your results help you? We truly hope they did. </p>',
    emailAddress: 'hello@prickpredictor.com',
    image: {
      alt: 'Heart icon',
      src: heart,
    },
  },
  newsletter: {
    copy:
      "<p>We're working hard to develop new materials to rid the world of pricks. <strong>Join our mission</strong> and we'll keep you posted!</p>",
  },
};

export default contact;



// WEBPACK FOOTER //
// ./src/locales/contact.js